import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import jwt from "jsonwebtoken";

import "./HeaderMobile.styles.css";
import "./HeaderTablet.styles.css";

import Logo from "../../../assets/img/mercari_logo.png";

import { Input } from "../../atom/Input";

const Mobile = ({ handleSearch, displayButtons, search }) => {
  return (
    <header>
      <div className="header__inner--mobile">
        <div className="header__top--mobile">
          <div className="header__logo">
            <img src={Logo} width="130px" alt="logo" />
          </div>
          <div>{displayButtons()}</div>
        </div>
        <div className="header__middle--mobile">
          <div className="header__input">
            <Input type="landing" data={search} setData={handleSearch} />
            <button>
              <svg
                aria-hidden="true"
                width="16"
                height="16"
                viewBox="0 0 16 16"
              >
                <path
                  fill="currentColor"
                  fillRule="nonzero"
                  d="M11.435 10.063h-.723l-.256-.247a5.92 5.92 0 0 0 1.437-3.87 5.946 5.946 0 1 0-5.947 5.947 5.92 5.92 0 0 0 3.87-1.437l.247.256v.723L14.637 16 16 14.637l-4.565-4.574zm-5.489 0A4.111 4.111 0 0 1 1.83 5.946 4.111 4.111 0 0 1 5.946 1.83a4.111 4.111 0 0 1 4.117 4.116 4.111 4.111 0 0 1-4.117 4.117z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
        <div className="header__bottom---mobile">
          <div className="header__search">
            <div className="header__search-icon">
              <svg width="20" height="16" viewBox="0 0 20 16">
                <path
                  fill="rgba(234, 53, 45)"
                  d="M18.799 15.25h-11.5a1.25 1.25 0 1 1 0-2.5h11.5a1.25 1.25 0 0 1 0 2.5zm0-6h-11.5a1.25 1.25 0 1 1 0-2.5h11.5a1.25 1.25 0 0 1 0 2.5zm0-6h-11.5a1.25 1.25 0 1 1 0-2.5h11.5a1.25 1.25 0 0 1 0 2.5zM2 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
                />
              </svg>
            </div>
            <div className="header__search-text">
              <p>カテゴリーから探す</p>
            </div>
          </div>
          <div className="header__search">
            <div className="header__search-icon">
              <svg width="23" height="16">
                <path
                  fill="rgba(234, 53, 45)"
                  d="M6.315 0L4.473 1.806 2.833.019.73 1.977l1.69 1.84L1.198 5.02c-1.594 1.594-1.594 4.188-.01 5.772L6.3 16h13.272a3.08 3.08 0 0 0 3.077-3.077V3.076A3.08 3.08 0 0 0 19.57 0H6.315zm13.46 12.925a.211.211 0 0 1-.205.205H7.504L3.227 8.771a1.226 1.226 0 0 1-.01-1.71L4.38 5.92l1.28 1.371a2.68 2.68 0 1 0 2.13-1.93L6.433 3.907 7.49 2.87h12.082a.211.211 0 0 1 .206.205v9.848h-.002z"
                />
              </svg>
            </div>
            <div className="header__search-text">
              <p>ブランドから探す</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

const Tablet = ({ handleSearch, displayButtons, search }) => {
  return (
    <header>
      <div className="header__inner--tablet">
        <div className="header__top--tablet">
          <div className="header__logo">
            <img src={Logo} width="130px" alt="logo" />
          </div>
          <Input type="landing" data={search} setData={handleSearch} />
        </div>
        <div className="header__bottom--tablet">
          <div className="header__left">
            <div className="header__search">
              <div>
                <div className="header__search-icon">
                  <svg width="20" height="16" viewBox="0 0 20 16">
                    <path
                      fill="rgba(234, 53, 45)"
                      d="M18.799 15.25h-11.5a1.25 1.25 0 1 1 0-2.5h11.5a1.25 1.25 0 0 1 0 2.5zm0-6h-11.5a1.25 1.25 0 1 1 0-2.5h11.5a1.25 1.25 0 0 1 0 2.5zm0-6h-11.5a1.25 1.25 0 1 1 0-2.5h11.5a1.25 1.25 0 0 1 0 2.5zM2 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
                    />
                  </svg>
                </div>
                <p className="header__search-text">カテゴリーから探す</p>
              </div>
            </div>
            <div className="header__search">
              <div>
                <div className="header__search-icon">
                  <svg width="23" height="16">
                    <path
                      fill="rgba(234, 53, 45)"
                      d="M6.315 0L4.473 1.806 2.833.019.73 1.977l1.69 1.84L1.198 5.02c-1.594 1.594-1.594 4.188-.01 5.772L6.3 16h13.272a3.08 3.08 0 0 0 3.077-3.077V3.076A3.08 3.08 0 0 0 19.57 0H6.315zm13.46 12.925a.211.211 0 0 1-.205.205H7.504L3.227 8.771a1.226 1.226 0 0 1-.01-1.71L4.38 5.92l1.28 1.371a2.68 2.68 0 1 0 2.13-1.93L6.433 3.907 7.49 2.87h12.082a.211.211 0 0 1 .206.205v9.848h-.002z"
                    />
                  </svg>
                </div>
                <p className="header__search-text">ブランドから探す</p>
              </div>
            </div>
          </div>
          <div className="header__right">{displayButtons()}</div>
        </div>
      </div>
    </header>
  );
};

export const LandingHeader = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  // オブジェクトが入れうとわかっていればからのオブジェクトを初期値に設定してあげる
  const [userInfo, setUserInfo] = useState({});
  const [search, setSearch] = useState("");

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setIsLoggedIn(false);
    }
    jwt.verify(token, process.env.REACT_APP_JWT_KEY, (err, decoded) => {
      // undefined null
      // もし途中でエラーが起こってしまったりtokenが一致しなければstateをfalseに
      if (err || !decoded) {
        setIsLoggedIn(false);
        return;
      }

      // うまくいった場合
      setIsLoggedIn(true);
      setUserInfo(decoded);
    });
  }, []);

  const logout = () => {
    // localstorageからtokenを取り除く
    localStorage.removeItem("token");
    setIsLoggedIn(false);
  };

  const displayButtons = () => {
    if (!isLoggedIn) {
      return (
        <div className="header__buttons">
          <div className="header__button--register">
            <Link to="/getstarted">新規会員登録</Link>
          </div>
          <div className="header__button--login">
            <Link to="/login">ログイン</Link>
          </div>
        </div>
      );
    }

    return (
      <div style={{ display: "flex" }}>
        {userInfo && userInfo.nickname ? (
          <p>ようこそ、{userInfo.nickname}さん</p>
        ) : null}
        <div style={{ backgroundColor: "blue" }}>
          <Link to="/users/items">商品ページ</Link>
        </div>
        <button onClick={logout}>ログアウト</button>
      </div>
    );
  };

  return (
    <div>
      <div className="header--tablet">
        <Tablet
          handleSearch={handleSearch}
          displayButtons={displayButtons}
          search={search}
        />
      </div>
      <div className="header--mobile">
        <Mobile
          handleSearch={handleSearch}
          displayButtons={displayButtons}
          search={search}
        />
      </div>
    </div>
  );
};
